'use strict';

exports.__esModule = true;
exports.update = update;

var _apiClient = require('../../network/api-client');

var _apiClient2 = _interopRequireDefault(_apiClient);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var API = {
  COURIER_USER: '/courier/user'

  /**
   * Wrapper for `/courier/locations/track` API endpoint
   */

};var user = {
  update: update
};

exports.default = user;

/**
 * TUpdate the account details of the current user
 * @param {string} data.push_id
 * @returns {promise} empty response, code: 204
 */

function update() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  return _apiClient2.default.put({ route: API.COURIER_USER, data: data });
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@quiqupltd/quiqupjs/lib/courier/user/user.js
// module id = 1185
// module chunks = 0